import React from 'react';

export default function ReturnsPage() {
  return <div>
    T3h Returns
  </div>;
}